import * as React from "react";
export let AddGST = (originalAmount, gstRate = 11) => {
    const gstAmount = (gstRate / 100) * originalAmount;
    return originalAmount + gstAmount;
};
export let Money = ({ children, gst }) => {
    return (React.createElement("span", null,
        !isNaN(Number(children))
            ? `$${parseFloat(children).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
            : "To be quoted",
        gst === 'not' && React.createElement("small", null,
            React.createElement("br", null),
            "* GST Not Included"),
        gst === 'inc' && React.createElement("small", null,
            React.createElement("br", null),
            "* GST Included")));
};
